/**
 * Password validation helpers for client-side checks.
 */
export interface PasswordRequirements {
  length: boolean;
  uppercase: boolean;
  lowercase: boolean;
  number: boolean;
  special: boolean;
}

export const passwordRequirementItems: Array<{
  key: keyof PasswordRequirements;
  labelKey: string;
}> = [
  { key: "length", labelKey: "auth.passwordRequirementLength" },
  { key: "uppercase", labelKey: "auth.passwordRequirementUppercase" },
  { key: "lowercase", labelKey: "auth.passwordRequirementLowercase" },
  { key: "number", labelKey: "auth.passwordRequirementNumber" },
  { key: "special", labelKey: "auth.passwordRequirementSpecial" },
];

/**
 * Calculates the current password requirement state for a given input.
 */
export const getPasswordRequirements = (password: string): PasswordRequirements => ({
  length: password.length >= 8,
  uppercase: /[A-Z]/.test(password),
  lowercase: /[a-z]/.test(password),
  number: /[0-9]/.test(password),
  special: /[^A-Za-z0-9]/.test(password),
});

/**
 * Returns true when all password requirements are satisfied.
 */
export const arePasswordRequirementsMet = (
  requirements: PasswordRequirements
): boolean => Object.values(requirements).every(Boolean);
